import React, { useState } from "react";
import { Box } from "@material-ui/core";
import moment from 'moment';
import { HELP_ICON,EMAIL_ICON, PHONE_ICON } from "assets/constants/Icons";

const HelpSupport = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const faqItems = [
    {
      question: "How can I contact support?",
      answer: `<ol>
                <li>Use the Help & Support option in the portal.</li>
                <li>Email us at support@millionai.com</li>
              </ol>`
    },
    {
      question: "What is the Million AI Portal?",
      answer: "The Million AI Portal is a unified platform designed to provide businesses and individuals with access to AI-powered tools, analytics, and process automation. It helps optimize workflows, manage subscriptions, track credit usage, and leverage AI-driven insights."
    },
    {
      question: "How do I create an account?",
      answer: "Go to the Sign Up page on the portal."
    },
    {
      question: "Can I log in using Google?",
      answer: "Yes. You can log in directly using your Google account for a quick and secure experience."
    },
    {
      question: "What are “Credits” in the portal?",
      answer: "Credits are the internal currency of Million AI Portal. They are consumed when you use AI tools, reports, or analytics. You can purchase additional credits through the Payment Gateway."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <Box className="main-content">
      <Box className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
        <Box className="col-md-10 sm_device">
          <i className={`${HELP_ICON} list-table-icon`}></i> Help & Support
        </Box>
        <Box className="col-md-2 sm_device" style={{ textAlign: 'right' }}>
          <i className="fas fa-calendar-alt" style={{ marginRight: '10px' }}></i>
          {moment().format("DD MMM YYYY")}
        </Box>
      </Box>
      <Box style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
      <div className="help-support-contact-wrapper">
        <div className="help-support-contact-div">
          <div className="help-support-contact-inner-div">
            <label><i className={`${EMAIL_ICON} list-table-icon`}></i><a href="mailto:support@millionai.com"> support@millionai.com</a> </label>
            <label className="ml-5"><i className={`${PHONE_ICON} list-table-icon`}></i><a href="tel:+919898989898"> +919898989898</a></label>
          </div>
        </div> 
      </div>
      <Box className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
        <Box className="col-md-10 sm_device">
          <i className={`${HELP_ICON} list-table-icon`}></i> FAQ
        </Box>
      </Box>
      <Box style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
      <Box className="list-wrapper">
        <section className="section section-md">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-9 col-xl-7">
                <div className="card-group-custom card-group-corporate">
                  {faqItems.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        border: "1px solid #ddd",
                        marginBottom: "10px",
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        onClick={() => toggleAccordion(index)}
                        style={{
                          padding: "15px",
                          cursor: "pointer",
                          background: "#f5f5f5",
                          fontWeight: "bold",
                        }}
                      >
                        {item.question}
                      </div>

                      {activeIndex === index && (
                        <div style={{ padding: "15px", background: "#fff" }}>
                          {item.answer}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </Box>
    </Box>
  );
};

export default HelpSupport;